const value = {
    pageTitle: 'User management',
    login: 'Login',
    email: 'Email',
    fio: 'Full name',
    role: 'Role',
    creationType: 'Creation type',
    active: 'Active',
    action: 'Action',
    systemRole: 'System role',
    status: 'Status',
    creationTypeLocal: 'Local',
  };

export default value;
